<!--
 * @Author: w9013327 v-maijiahua@oppo.com
 * @Date: 2022-11-11 09:51:17
 * @LastEditors: W9013327 v-maijiahua@oppo.com
 * @LastEditTime: 2024-01-15 11:42:46
 * @FilePath: \community-backendf:\community-frontend\src\components\circleTag.vue
 * @Description: 
-->
<template>
  <!-- 1+app不利用路由标签跳转 -->
  <router-link
    class="circle-tag"
    :style="{
      opacity: Number(!!tagVisible),
    }"
    :to="(isApp && route.name === 'abroadList') || isOneplus || !tagVisible
      ? {}
      : circleRoute
    "
    @click.stop="onJump"
  >
    <svg-icon name="icon-circle" v-if="iconVisible"></svg-icon>
    <span>{{ tagName }}</span>
  </router-link>
</template>

<script setup>
import { ref, getCurrentInstance, computed, nextTick } from "vue";
import { useSystemStore } from "@/stores/system";
import { useUserStore } from "@/stores/user";
import { storeToRefs } from "pinia";

import { useRoute, useRouter } from "vue-router";

import { useSearchStore } from "@/stores/search";
const searchStore = useSearchStore();
const { visible, wapVisible } = storeToRefs(searchStore);

const route = useRoute();
const router = useRouter();

const { proxy } = getCurrentInstance();

const systemStore = useSystemStore();
const { isApp, isOneplus, versionCode } = storeToRefs(systemStore);
const userStore = useUserStore();
const props = defineProps({
  circleInfo: {
    type: Object,
    default: () => {
      return {};
    },
  },
  showTag: {
    type: Boolean,
    default: true,
  },
  index: {
    type: Number,
    default: 0,
  },
  showTab: {
    type: Boolean,
    default: false,
  },
});

// 圈子Id
const circleId = computed(() => props.circleInfo.id);
// 圈子名称
const circleName = computed(() => props.circleInfo.name);
// 圈子tab信息
const circleTabInfo = computed(() => props.circleInfo?.circleTab)
// 发帖人
const uid = computed(() => props.circleInfo.uid);
// 是否展示tag
const tagVisible = computed(() => {
  return !!props.showTag || (!!props.showTab && !!circleTabInfo.value?.id);
});
// 是否展示圈子icon
const iconVisible = computed(() => {
  return props.showTag && !props.showTab;
});

/**
 * 标签名：圈子，圈子tab，个人主页
 * 圈子和圈子tab不存在同时并存的情况
 * 要么显示圈子，圈子不存在则显示个人主页
 * 要么显示圈子tab
 **/
const tagName = computed(() => {
  let name = "";
  if (props.showTag) {
    name = circleName.value || proxy.$t("myProfile");
  }
  if (props.showTab) {
    name = circleTabInfo.value?.name;
  }
  return name;
});

const circleRoute = computed(() => {
  let tagRoute = {};
  // 展示圈子，无圈则个人主页
  if (props.showTag) {
    tagRoute = {
      name: circleId.value ? 'circle' : 'user',
      params: {
        id: circleId.value || uid.value
      }
    }
  }
  // 圈子tab
  if (props.showTab) {
    tagRoute = {
      name: "circle",
      params: {
        id: circleId.value,
        tabId: circleTabInfo.value?.id,
      },
    };
  }
  return tagRoute;
});

const onJump = () => {
  if (!tagVisible.value) return;
  proxy.$ga("circle_detail_entry", {
    screen_name: route.name,
    circle_id: circleId.value,
    circle_name: circleName.value,
    circle_category: "",
    entry_position: route.name,
    position: props.index + 1,
  });
  // 用于关闭搜索窗口
  nextTick(() => {
    visible.value = false
    wapVisible.value = false
  })
  // 1+app低版本通过路由跳转，不打开原生页面
  if (isOneplus.value && versionCode.value < 41600) {
    // 展示圈子，无圈则个人主页
    if (props.showTag) {
      router.push({
        name: circleId.value ? 'circle' : 'user',
        params: {
          id: circleId.value || uid.value
        }
      });
      return;
    }
    // 圈子tab
    if (props.showTab) {
      router.push({
        name: "circle",
        params: {
          id: circleId.value,
          tabId: circleTabInfo.value?.id,
        },
      });
      return;
    }
  }
  // 1+app新版本及其余app均通过原生方法跳转
  if ((isApp.value && route.name === "abroadList") || isOneplus.value) {
    let path = ''
    if (props.showTag) {
      path = circleId.value ? `circle/${circleId.value}` : `user/${uid.value}`;
    }
    if (props.showTab) {
      path = `circle/${circleId.value}/${circleTabInfo.value?.id}`
    }
    proxy.$openNewWebview(`${location.origin}/${path}`);
  }
};
</script>

<style lang="postcss" scoped>
.circle-tag {
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: center;
  background-color: var(--backgroung-light-theme);
  border-radius: 4px;
  padding: 7px 8px 7px 8px;
}
span {
  font-size: 14px;
}
.svg-icon {
  width: 16px;
  height: 16px;
  color: var(--theme);
  margin-right: 8px;
}

@media screen and (max-width: 1023px) {
  span {
    font-size: 12px;
    height: 14px;
  }
  .svg-icon {
    width: 14px;
    height: 14px;
  }
}
</style>
